var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"grabBoxContainer"},[_c('div',{ref:"grabBox",staticClass:"bottom-grabber",class:{'grabbed px-4':_vm.isGrabbed, 'ungrabbed': !_vm.isGrabbed}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }